import { Outlet } from "react-router";

import { BUILTIN_PLUGINS, PluginProvider } from "@/platform/plugins";
import { SheetProvider } from "@/shared/components/sheet";

export function AppLayout() {
  return (
    <PluginProvider builtinPlugins={BUILTIN_PLUGINS}>
      <SheetProvider>
        <Outlet />
      </SheetProvider>
    </PluginProvider>
  );
}
